const styles = theme => ({
    progress: {
        margin: theme.spacing(-5, -3),
        position: 'absolute',
        top: '50%',
        left: '50%',
    }
});
export default styles;
